import { useMemo } from 'react'
import { useWorld } from '../contexts/WorldDataContext'
import { buildLookup, type WorldLookup } from '../utils/progressionLookup'

/** Acceso a los datos del servidor para enlazar materiales, monstruos y mapas de las guías. */
export function useWorldLookup(): { status: string; lookup?: WorldLookup } {
  const world = useWorld()
  const lookup = useMemo(() => (world.data ? buildLookup(world.data) : undefined), [world.data])
  return { status: world.status, lookup }
}
